import * as React from 'react';
import {
    TextField,
    Button,
    Container,
    Box,
    Toolbar,
    Typography,
} from '@mui/material';
import ModernNavbar from '../setup/ModernNavbar';
import StickyTable from '../../BuiltInComponent/TableWithPagination';
import Footer from '../setup/Footer';
import Loading from '../../BuiltInComponent/Loading';
import { useDispatch, useSelector } from 'react-redux';
import { getDesignations, getSingleDesignation, addDesignation, editDesignation, deleteDesignation } from '../../features/AdminManagement/designationsSlice';

const DesignationsForm = () => {

    const dispatch = useDispatch();

    const { designations, isLoading } = useSelector((state) => state.desig);

    const tableColumns = [
        { fieldName: 'desigID', cName: 'unitID', textAlign: 'right', dType: 'string', status: 'en' },
        { fieldName: 'desigName', cName: 'Designation', textAlign: 'left', dType: 'string', status: 'en' },
        { fieldName: 'Edit', cName: 'Edit', width: 50, textAlign: 'center', dType: 'string', status: 'en' },
        { fieldName: 'Delete', cName: 'Delete', width: 50, textAlign: 'center', dType: 'string', status: 'en' },
        { fieldName: 'Delete', cName: 'Delete', width: 50, textAlign: 'center', dType: 'string', status: 'dis' },
    ]

    React.useEffect(() => {
        dispatch(getDesignations())
    }, [dispatch]);

    const [desigData, setDesigData] = React.useState({
        desigID: '',
        desigName: '',
        desigStatus: true,
    });

    const handleChange = (e) => {
        setDesigData({
            ...desigData,
            [e.target.name]: e.target.value,
        });
    };

    const onEditClick = async (id) => {
        dispatch(getSingleDesignation(id)).then((res) => {
            setDesigData({
                ...desigData,
                desigID: res.payload.desigID,
                desigName: res.payload.desigName,
                desigStatus: res.payload.desigStatus,
            })
        })
    }
    const onDeleteClick = async (id) => {
        dispatch(deleteDesignation(id)).then(() => {
            dispatch(getDesignations())
        })
    }
    const handleSubmit = (e) => {
        e.preventDefault();
        if (desigData.desigID === '') {
            dispatch(addDesignation(desigData)).then(() => {
                dispatch(getDesignations()).then(() => {
                    setDesigData({
                        ...desigData,
                        desigID: '',
                        desigName: '',
                        desigStatus: '',
                    })
                })
            })
        } else {
            dispatch(editDesignation(desigData)).then(() => {
                dispatch(getDesignations()).then(() => {
                    setDesigData({
                        ...desigData,
                        desigID: '',
                        desigName: '',
                        desigStatus: '',
                    })
                })
            })
        }
    };

    return (
        <>
            <ModernNavbar />
            <Toolbar />
            <Container maxWidth='sm'>
                <Box sx={{ background: 'linear-gradient(90deg, rgba(16,191,248,1) 0%, rgba(12,150,180,1) 100%)', mb: 3, borderRadius: 2, color: 'white', textShadow: 'black 4px 4px 10px' }}>
                    <Typography sx={{ textAlign: 'center', fontSize: 30, fontWeight: 'bolder' }}> Designation</Typography>
                </Box>
                <TextField
                    id="outlined-basic"
                    label="Designation"
                    variant="outlined"
                    name="desigName"
                    value={desigData.desigName}
                    onChange={handleChange}
                    fullWidth
                />
                <Button variant='contained' fullWidth sx={{ mt: 2, color: 'white', fontSize: 20, fontWeight: 'bolder' }} onClick={handleSubmit}>SAVE</Button>
                {isLoading ?
                    <>
                        <Loading />
                    </>
                    :
                    <>
                        <StickyTable
                            tableColumns={tableColumns}
                            tableData={designations && designations}
                            onEditClick={onEditClick}
                            onDeleteClick={onDeleteClick} />
                    </>}
            </Container>
            <Footer />
        </>
    );
};

export default DesignationsForm;
